const environment = process.env.REACT_APP_ENVIRONMENT;
const localPort = process.env.REACT_APP_API_PORT;
let apiRequestUrl = '';

switch (environment) {
    case 'local':
        apiRequestUrl = `http://localhost:${ localPort }`;
        break;
    case 'staging':
        apiRequestUrl = 'https://api-staging.simplybenefits.ca';
        break;
    case 'production':
        apiRequestUrl = 'https://api.simplybenefits.ca';
        break;
    default:
        apiRequestUrl = `http://localhost:${ localPort }`;
        break;
}

export default {
    apiRequestUrl
};